// eslint-disable-next-line import/prefer-default-export
export const getGames = () => {
  // eslint-disable-next-line no-undef
  const games = config.VUE_APP_GAMES || process.env.VUE_APP_GAMES

  if (!games) {
    return []
  }

  return games.replaceAll(' ', '').split(',')
}

export const GAME = Object.freeze({
  Joker: 'joker',
  Lotto: 'lotto',
  Lotto12: 'lotto12',
  Vn99: 'vn99',
  Sport99: 'sport99',
})

export const GAME_TYPE = Object.freeze({
  Sabong: 1,
  Baccarat: 2,
  Joker: 3,
  Lotto: 4,
  Lotto12: 6,
  Vn99: 5,
  Sport99: 7,
})
